import { setVisible } from "@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions";
import AmountPriceContainer from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import { first, get, values } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AmountPrice from "../../Components/AmountPrice/AmountPrice";
import { addToBasket, setShowSelector } from "../../Reducers/Basket/Actions";
import { showOutfit } from "../../Reducers/Outfit/Actions";

const CustomAmountPriceContainer = (props) => {
  const dispatch = useDispatch();
  // @ts-ignore
  const { isLoggedIn } = useSelector((state) => state.login);
  const { code, configurationType } = useSelector(
    // @ts-ignore
    (state) => state.configurator.configuration
  );
  const selectedDesignViewIdentifier = useSelector((state) =>
    get(state, "designView.designViews[0].identifier", null)
  );
  const getScreenshotImage = async () => {
    const screenshot = await Services.visualization.getScreenshots();
    return selectedDesignViewIdentifier
      ? first(values(screenshot))[selectedDesignViewIdentifier]
      : null;
  };
  // @ts-ignore
  const { isOutfitVisble, screenshot } = useSelector((state) => state.outfit);

  return (
    <AmountPriceContainer
      {...props}
      Component={AmountPrice}
      isLoggedIn={isLoggedIn}
      code={code}
      configurationType={configurationType}
      addToBasket={(code) => dispatch(addToBasket(code))}
      getScreenshotImage={getScreenshotImage}
      updateGlobalLoader={(flag) => dispatch(setVisible("globalLoader", flag))}
      setShowSelector={(flag) => dispatch(setShowSelector(flag))}
      isOutfitVisble={isOutfitVisble}
      screenshot={screenshot}
      onCloseOutfit={() => dispatch(showOutfit(false, null))}
    />
  );
};

export default CustomAmountPriceContainer;
